import { Desktop, Hub, LogoAvatar } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'
import type { SidebarManifest } from 'modules/core/lib/manifests/types'

import './sidebar.css'

export const sidebarManifest: SidebarManifest = (navigation) => {
  return [
    {
      identifier: 'device_catalog',
      name: i18n.t('it_management.sidebar.device_catalog'),
      factorialOneIcon: Hub,
      path: '/device-catalog',
      group: 'it_management',
      module: 'device_catalog',
      priority: 'highest',
    },
    {
      identifier: 'it_inventory',
      name: i18n.t('it_management.sidebar.it_inventory'),
      factorialOneIcon: Desktop,
      path: navigation.it_management.fullPath(),
      group: 'it_management',
      module: 'it_management',
      priority: 'high',
    },
    {
      identifier: 'factorial_it',
      name: i18n.t('it_management.sidebar.factorial_it'),
      factorialOneIcon: LogoAvatar,
      path: 'https://it.factorialhr.com/',
      group: 'it_management',
      module: 'factorial_it',
      priority: 'medium',
      target: '_blank',
    },
  ]
}
